import { Sheet, Icon } from '@/ui'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { TransactionDetails } from '../transaction-details'
import { TransactionOrSplit } from '@/reducers/admin/allTransactions.slice'
import { useEffect, useRef } from 'react'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  transaction: TransactionOrSplit
  review?: boolean
  activeTabIndex: number
  isManualTransaction: boolean
  setPreventClose: (val: boolean) => void
  preventClose: boolean
}

export const TransactionDetailsSheet = ({
  open,
  onOpenChange,
  transaction,
  review,
  activeTabIndex,
  isManualTransaction,
  setPreventClose,
  preventClose,
}: Props) => {
  const preventCloseRef = useRef(preventClose)

  useEffect(() => {
    preventCloseRef.current = preventClose
  }, [preventClose])

  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen && preventCloseRef.current) return
    onOpenChange(nextOpen)
  }

  return (
    <Sheet open={open} onOpenChange={handleOpenChange}>
      <Sheet.Content side="right" className="w-full sm:max-w-md " dismissible>
        <Sheet.Title className="flex items-center gap-2 mb-2">
          <Icon icon={solid('coins')} className="w-4 h-4" />
          Transaction Details
        </Sheet.Title>
        <TransactionDetails
          transactionId={transaction.id}
          review={review}
          parentId={transaction.splitFrom ?? undefined}
          defaultActiveIndex={activeTabIndex}
          isManualTransaction={isManualTransaction}
          setPreventClose={setPreventClose}
        />
      </Sheet.Content>
    </Sheet>
  )
}
